let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dF9x9")).then(() => parcelRequire('d68Yw'));